import {useTranslation} from 'react-i18next'

import AmbientMapLegend from './AmbientMapLegend'
import CommonMapLegend from './CommonMapLegend'

const ComparisonMapLegends = ({items = []}) => {
  const {t} = useTranslation()
  const visibleItems = items
    .filter((item) => item?.legend && item?.type)
    .sort((left, right) => {
      const roleOrder = {compare: 0, base: 1}

      return (roleOrder[left.role] ?? 2) - (roleOrder[right.role] ?? 2)
    })

  if (visibleItems.length === 0) {
    return null
  }

  const getRoleLabel = (role) =>
    role === 'base'
      ? t('lands:view.comparison.fields.base_layer')
      : t('lands:view.comparison.fields.compare_layer')

  return (
    <div className='gis-map-legend-stack gis-map-legend-stack--comparison'>
      {visibleItems.map((item) => {
        const commonProps = {
          key: `${item.role}-${item.type}-${item.label}`,
          layerLabel: item.label,
          roleLabel: getRoleLabel(item.role),
        }

        if (item.type === 'ambient') {
          return <AmbientMapLegend {...commonProps} ambient={item.legend} />
        }

        return (
          <CommonMapLegend
            {...commonProps}
            enhancementScope='comparison'
            headers={item.legend}
            showEnhance={Boolean(item.isEnhanceable)}
          />
        )
      })}
    </div>
  )
}

export default ComparisonMapLegends
